module.exports = __webpack_public_path__ + "img/noread.c24375d9.svg";